import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  const featuredCategories = categories.slice(0, 8);

  const getCategoryColorClasses = (color: string) => {
    switch (color) {
      case 'accent':
        return 'bg-accent-100 text-accent-700 group-hover:bg-accent-200';
      case 'primary':
        return 'bg-primary-100 text-primary-700 group-hover:bg-primary-200';
      case 'secondary':
        return 'bg-secondary-100 text-secondary-700 group-hover:bg-secondary-200';
      default:
        return 'bg-accent-100 text-accent-700 group-hover:bg-accent-200';
    }
  };

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="text-2xl md:text-4xl font-bold text-foreground-950 font-heading mb-3">
              热门频道
            </h2>
            <p className="text-sm md:text-base text-foreground-600 max-w-lg mx-auto">
              十二大精彩频道，发现你感兴趣的一切
            </p>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
            {featuredCategories.map((category) => (
              <Link
                key={category.slug}
                to={`/category/${category.slug}`}
                className="group bg-background-50 rounded-xl p-5 md:p-6 text-center hover:bg-background-200/50 transition-all duration-300 cursor-pointer"
              >
                <div className={`w-12 h-12 md:w-14 md:h-14 mx-auto rounded-xl flex items-center justify-center transition-colors duration-200 ${getCategoryColorClasses(category.color)}`}>
                  <i className={`${category.icon} text-xl md:text-2xl`}></i>
                </div>
                <h3 className="mt-3 text-sm md:text-base font-semibold text-foreground-950">
                  {category.name}
                </h3>
                <p className="mt-1 text-xs text-foreground-500 line-clamp-1">
                  {category.description}
                </p>
              </Link>
            ))}
          </div>

          <div className="mt-8 grid grid-cols-2 sm:grid-cols-4 gap-3">
            {categories.slice(8).map((category) => (
              <Link
                key={category.slug}
                to={`/category/${category.slug}`}
                className="flex items-center gap-2 px-4 py-3 bg-background-50 rounded-lg hover:bg-background-200/50 transition-colors duration-200 text-sm text-foreground-700 hover:text-foreground-950 cursor-pointer"
              >
                <i className={`${category.icon} text-base`}></i>
                <span className="font-medium">{category.name}</span>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}